import TAX_BENEFITS_FORM from "./taxBenefits/taxBenefitsForm";
import TAX_BENEFITS_VALIDATION from "./taxBenefits/taxBenefitsValidationRules";
import COVERAGE_CERTIFICATE_FORM from "./coverageCertificate/coverageCertificateForm";
import COVERAGE_CERTIFICATE_VALIDATION from "./coverageCertificate/coverageCertificateValidationRules";
import COVERAGE_STATUSES_FORM from "./coverageStatuses/coverageStatusesForm";
import COVERAGE_STATUSES_VALIDATION from "./coverageStatuses/coverageStatusesValidationRules";
import DEPENDENT_PERSON_COVERAGES_TERMINATIONS_FORM from "./dependentPersonCoveragesTerminations/dependentPersonCoveragesTerminationsForm";
import DEPENDENT_PERSON_COVERAGES_TERMINATIONS_VALIDATION from "./dependentPersonCoveragesTerminations/dependentPersonCoveragesTerminationsValidationRules";
import PAYROLL_DEDUCTIONS_FORM from "./payrollDeductions/PayrollDeductionsForm";
import PAYROLL_DEDUCTIONS_VALIDATION from "./payrollDeductions/payrollDeductionsValidationRules";

export default {
  TAX_BENEFITS: {
    form: TAX_BENEFITS_FORM,
    rules: TAX_BENEFITS_VALIDATION,
  },
  COVERAGE_CERTIFICATE: {
    form: COVERAGE_CERTIFICATE_FORM,
    rules: COVERAGE_CERTIFICATE_VALIDATION,
  },
  COVERAGE_STATUSES: {
    form: COVERAGE_STATUSES_FORM,
    rules: COVERAGE_STATUSES_VALIDATION,
  },
  DEPENDENT_PERSON_COVERAGES_TERMINATIONS: {
    form: DEPENDENT_PERSON_COVERAGES_TERMINATIONS_FORM,
    rules: DEPENDENT_PERSON_COVERAGES_TERMINATIONS_VALIDATION,
  },
  PAYROLL_DEDUCTIONS: {
    form: PAYROLL_DEDUCTIONS_FORM,
    rules: PAYROLL_DEDUCTIONS_VALIDATION,
  },
};



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/reports/forms/index.js